var React = require('react');

function WidthIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"XMLID_223_","d":"M325.607,154.394l-75-75c-4.289-4.291-10.743-5.572-16.347-3.252C228.654,78.463,225,83.933,225,90v60H105\r\n\tV90c0-6.067-3.654-11.537-9.26-13.858c-5.603-2.32-12.057-1.039-16.347,3.252l-75,75c-5.858,5.858-5.858,15.355,0,21.213l75,75\r\n\tc2.869,2.87,6.706,4.394,10.609,4.394c1.933,0,3.882-0.374,5.737-1.142c5.605-2.322,9.26-7.792,9.26-13.858v-60h120v60\r\n\tc0,6.067,3.654,11.537,9.26,13.858c1.855,0.769,3.805,1.142,5.737,1.142c3.903,0,7.74-1.524,10.609-4.394l75-75\r\n\tC331.465,169.749,331.465,160.252,325.607,154.394z M75,203.787L36.213,165L75,126.213V203.787z M255,203.787v-77.573L293.787,165\r\n\tL255,203.787z"}));
}

WidthIconInline.defaultProps = {"fill":"#000000","height":"800px","width":"800px","version":"1.1","id":"Layer_1","viewBox":"0 0 330 330","xmlSpace":"preserve"};

module.exports = WidthIconInline;

WidthIconInline.default = WidthIconInline;
